import script from "./DeliverySetting.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeliverySetting.vue?vue&type=script&setup=true&lang=ts"

import "./DeliverySetting.vue?vue&type=style&index=0&id=71c52b36&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71c52b36"]])

export default __exports__